'use client';

import { useEffect, useState } from 'react';

export interface TocItem {
  id: string;
  label: string;
}

/** "Nesta página" com scrollspy via IntersectionObserver. */
export function DocsToc({ items }: { items: TocItem[] }) {
  const [active, setActive] = useState(items[0]?.id ?? '');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) setActive(entry.target.id);
        }
      },
      { rootMargin: '-104px 0px -70% 0px' },
    );
    for (const it of items) {
      const el = document.getElementById(it.id);
      if (el) observer.observe(el);
    }
    return () => observer.disconnect();
  }, [items]);

  return (
    <aside className="toc">
      <div className="t">nesta página</div>
      {items.map((it) => (
        <a key={it.id} href={`#${it.id}`} className={active === it.id ? 'on' : ''}>
          {it.label}
        </a>
      ))}
    </aside>
  );
}
